export default function () {
	const groupHovers = document.querySelectorAll('.group-hover');
  const hamburger = document.querySelector('.hamburger');
	const inertEls = document.querySelectorAll('#site-main, #site-footer, #contact-btn, #skip-to-content, .nav-wrapper:not(.overlay)');
  const overlay = document.querySelector("#overlay-menu");
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // group hover
  if(!prefersReducedMotion) {
    groupHovers.forEach((group) => {
      const links = group.querySelectorAll('.group-item');

      links.forEach((link) => {

        link.addEventListener('mouseover', function () {
          links.forEach((l) => {
            const nextElementSibling = l.nextElementSibling;

            if (link != l) {
              l.classList.add('opacity-25');
            }

            if (nextElementSibling?.tagName.toLowerCase() === 'span' && nextElementSibling.hasAttribute('data-menu-tiret')) {
              nextElementSibling.classList.add('opacity-25');
            }
          });
        });

        link.addEventListener('mouseout', function () {
          links.forEach((l) => {
            const nextElementSibling = l.nextElementSibling;

            if (link != l) {
              l.classList.remove('opacity-25');
            }

            if (nextElementSibling?.tagName.toLowerCase() === 'span' && nextElementSibling.hasAttribute('data-menu-tiret')) {
              nextElementSibling.classList.remove('opacity-25');
            }
          });
        });

      });
    });
  }

  // mobile menu
	hamburger?.addEventListener('click', function () {
		if (document.body.classList.contains('overlay-is-active')) {
			closeMenuOverlay();
		} else {
			openMenuOverlay();
		}
	});

  const openMenuOverlay = () => {
    if(prefersReducedMotion) {
      document.body.classList.add('overlay-is-active');
    } else {
      document.body.classList.add('overlay-is-active', 'opening');
    }
    hamburger.setAttribute('aria-expanded', 'true');
    inertEls.forEach((el) => {
      el.setAttribute('inert', '');
    });

    overlay.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeMenuOverlay();
        hamburger.focus();
      }
    });
  }

  const closeMenuOverlay = () => {
    if(prefersReducedMotion) {
      document.body.classList.remove('overlay-is-active');
    } else {
      document.body.classList.add('closing');
    }
    hamburger.setAttribute('aria-expanded', 'false');
    inertEls.forEach((el) => {
      el.removeAttribute('inert');
    });
  }

	let iteration = 0;
	document.addEventListener('animationstart', (event) => {
		if (event.animationName === 'menu-disappear') {
			iteration++;
		}
		if (event.animationName === 'menu-appear') {
			iteration++;
		}
	});

	document.addEventListener('animationend', (event) => {
		if (event.animationName === 'menu-disappear' && iteration >= 5) {
			setTimeout(() => {
				document.body.classList.remove('overlay-is-active', 'closing');
			}, 300);
			iteration = 0;
		}
		if (event.animationName === 'menu-appear' && iteration >= 5) {
			setTimeout(() => {
				document.body.classList.remove('opening');
			}, 300);
			iteration = 0;
		}
	});
}
